import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { CommentInput } from '@/atoms/input'

import FieldWrapper from './field-wrapper'

export interface CommentProps {
  label?: string
  fieldProps?: SpaceProps & WidthProps
  name?: string
  placeholder?: string
  buttonText?: string
  loading?: boolean
  disabled?: boolean
  tooltip?: string
}

const CommentField: FunctionComponent<CommentProps> = ({
  label,
  fieldProps,
  name,
  placeholder,
  buttonText,
  loading,
  disabled,
  tooltip,
}: CommentProps) => {
  const [field, meta] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} tooltip={tooltip}>
      <CommentInput
        id={field.name}
        value={field.value}
        placeholder={placeholder}
        buttonText={buttonText}
        loading={loading}
        disabled={disabled}
        hasError={hasError}
        {...field}
      />
    </FieldWrapper>
  )
}

CommentField.displayName = 'CommentField'

export default CommentField
